import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modeling',
  templateUrl: './modeling.component.html',
  styleUrls: ['./modeling.component.scss']
})
export class ModelingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
